import "../styles/bidding-list-item.scss";
import { getTimeDiff, fileExist } from "../shared/utils";
import { isMobile } from 'react-device-detect';
import { ImageWithDefault } from "./ImageWithDefault";
import { CountdownTimer } from "./CountdownTimer";
import { Box, IconButton, Typography } from "@mui/material";
import { Star, StarBorderOutlined } from "@mui/icons-material";
import { useState } from "react";
import { setFavoriteBidding } from "./api";
import { setNotificationMessage, setShowNotification } from "../store";

export const BiddingListItem = (props) => {
    const { data, status, onClick, onFavoriteChange, removing, ...restProps } = props;

    const [isFavorite, setIsFavorite] = useState(data.isFavorite);

    const carTitle = data?.countAdditionalCars > 0
        ? `Автомобильное комбо! ${data?.countAdditionalCars + 1} АВТО ПО ЦЕНЕ 1`
        : data?.car?.model?.name;

    const handleFavoriteClick = (e) => {
        e.stopPropagation();
        setFavoriteBidding(data.id, !isFavorite)
            .then(_ => {
                if(typeof(onFavoriteChange) === "function")
                    onFavoriteChange(data?.id, !isFavorite);
                setIsFavorite(!isFavorite);
            })
            .catch(err => {
                if(err?.status === 401) {
                    setNotificationMessage("Для добавления лота в избранное необходимо авторизоваться");
                    setShowNotification(true);
                }
                else {
                    console.log(err);
                    setNotificationMessage("Произошла непредвиденная ошибка");
                    setShowNotification(true);
                }
            })
    };

    return (
        <div
            key={data?.id}
            className={`${isMobile ? "bidding-list-item__mobile" : "bidding-list-item"}${removing ? " bidding-list-item--removing" : ""}`}
            onClick={onClick}
            {...restProps}
        >
            <div className="bidding-list-item__header">
                <h3>Лот № {data?.id}. {new Date(data.dateStartBidding).toLocaleDateString('ru-RU')}</h3>
                <IconButton onClick={handleFavoriteClick} style={!isMobile ? { width: 40 } : {}}>
                    {isFavorite ? <Star /> : <StarBorderOutlined />}
                </IconButton>
            </div>

            <div className={isMobile ? "bidding-list-item__main" : "bidding-list-item__main"}>
                {
                    isMobile
                        ? (
                            <div className="bidding-list-item__image-container__mobile">
                                <ImageWithDefault src={data?.fileName} />
                            </div>)
                        : <div className="bidding-list-item__image-container">
                            <ImageWithDefault src={data?.fileName} className={!isMobile ? "bidding-list-item__image" : ""} />
                        </div>
                }

                <div className={isMobile ? "bidding-list-item__info__mobile" : "bidding-list-item__info"}>
                    <p>🌍 {data?.city?.name}</p>
                    <h2>{carTitle}</h2>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", width: "100%", textAlign: "center", marginTop: "10px" }}>
                        <div>
                            <Box>
                                <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                    Длительность:
                                </Typography>
                                <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                    {data.duration}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                    Начальная цена:
                                </Typography>
                                <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                    {data.startPrice.toLocaleString()} ₽
                                </Typography>
                            </Box>
                        </div>
                        <div>
                            <Box>
                                <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                    Оставшееся время:
                                </Typography>
                                <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                    {data?.dateEndBidding ? <CountdownTimer endTime={data.dateEndBidding} /> : "Время вышло!"}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                    Текущая цена:
                                </Typography>
                                <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                    {data.endPrice ? data.endPrice.toLocaleString() : data.startPrice.toLocaleString()} ₽
                                </Typography>
                            </Box>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}